import { COOKIE_NAMES } from 'constants/cookiesNames';

import { YA_COUNTERS_WINDOW_NAMES } from 'shared/config/analytics';

export const readClientIdFromCookie = (getCookie: (cookieName: string) => string | undefined) =>
  getCookie(COOKIE_NAMES.googleAnalytics)?.slice(6);

export const readYandexClientIdFromCookieOrScript = (
  getCookie: (cookieName: string) => string | undefined,
  isWl: boolean,
) =>
  getCookie(COOKIE_NAMES.yandexAnalytics) ||
  (isWl
    ? window?.[YA_COUNTERS_WINDOW_NAMES.yandexCounterWL]?.getClientID()
    : window?.[YA_COUNTERS_WINDOW_NAMES.yandexCounter]?.getClientID());
